import {
  Heading,
  Flex,
  Box,
  Image,
  Text,
  Center,
  useDisclosure,
  Badge,
  VStack,
  Spacer,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import viewEditSrc from '../../../assets/vectors/view-edit.svg';
import DeleteTemplateModal from '../../modals/DeleteTemplateModal';
import DeleteTemplateButton from '../pass-templates/DeleteTemplateButton';
import PreviewWebsitePage from './PreviewWebsitePage';
import { useContext } from 'react';
import { MeContext } from '../../../context/MeContext';

function PassDownloadTemplatesListItem({ previewData }) {
  const meCtx = useContext(MeContext);
  const { entities } = meCtx.state;
  const isOrgAdmin = meCtx.state.account?.role === 'org_admin';
  const { isOpen, onClose } = useDisclosure();

  const isEditable = isOrgAdmin || !previewData.defaultForOrg;

  const determineDefaultTag = () => {
    if (entities.length === 1) {
      return 'Default page';
    } else {
      if (previewData?.attributes?.defaultForOrg === true) {
        return 'Default organisation page';
      } else {
        return 'Default entity page';
      }
    }
  };

  return (
    <>
      <Box pos="relative">
        <PreviewWebsitePage listItem previewData={previewData} />
        <Flex
          pos="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          bg="rgba(41, 50, 58, 0.8)"
          color="white"
          alignItems="center"
          justifyContent="center"
          opacity="0"
          transition="0.3s"
          _hover={{ opacity: 1 }}
        >
          {isEditable ? (
            <Center
              flexDir="column"
              as={RouterLink}
              to={previewData.editUrl}
              role="group"
            >
              <Image w="64px" src={viewEditSrc} alt="" />
              <Text
                fontSize="13px"
                textStyle="headingFamilyMedium"
                mt="10px"
                _groupHover={{ textDecoration: 'underline' }}
              >
                View
                <Box as="span" color="brand">
                  /
                </Box>
                Edit
              </Text>
            </Center>
          ) : (
            <Center flexDir="column" px={4}>
              <Text
                fontSize="13px"
                textStyle="headingFamilyMedium"
                textAlign="center"
              >
                Only organisation admins can edit this page
              </Text>
            </Center>
          )}
        </Flex>
      </Box>
      <Flex mt={5} px={4}>
        <Spacer />
        <VStack spacing={2}>
          <Heading fontSize="18px" textAlign="center">
            {previewData.name}
          </Heading>
          {(previewData?.attributes?.defaultForOrg === true ||
            previewData?.attributes?.entityIds.length > 0) && (
            <Badge
              backgroundColor={
                previewData.defaultForOrg === true ? 'brand' : '#5F6971'
              }
            >
              <Text color="white" fontSize="12px" textAlign="center">
                {determineDefaultTag()}
              </Text>
            </Badge>
          )}
        </VStack>

        <Spacer />

        {!previewData.defaultForOrg && (
          <Flex gap={2} data-testid="action-buttons-container">
            <DeleteTemplateButton
              previewData={previewData}
              isPassDownloadTemplate
            />
          </Flex>
        )}
      </Flex>
      <DeleteTemplateModal
        isOpen={isOpen}
        onClose={onClose}
        isPassDownloadTemplate
        portalProps={{
          deletePassDownloadTemplateUrl: 'api/v1/pass_download_templates',
        }}
      />
    </>
  );
}

export default PassDownloadTemplatesListItem;
